import { jsx } from 'react/jsx-runtime';

const SvgMiscBolt = (props) => jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props, { children: jsx("path", { fill: "#2D2E2E", d: "M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20Zm4.87-11L11 18v-5H7.13L13 6v5h3.87Z" }) }));

export { SvgMiscBolt as default };
//# sourceMappingURL=MiscBolt.es.js.map
